import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database types
export interface DbArticle {
  id: string
  user_id: string
  url: string
  title: string | null
  content: string | null
  excerpt: string | null
  word_count: number | null
  source_type: 'article' | 'youtube' | 'pdf' | 'newsletter'
  source_metadata: Record<string, unknown>
  is_read: boolean
  is_favorite: boolean
  is_archived: boolean
  archived_at: string | null
  reading_progress: number
  scroll_position: number
  ai_summary: Record<string, unknown> | null
  chat_history: unknown[]
  snoozed_until: string | null
  device_id: string | null
  created_at: string
  updated_at: string
}

export interface DbHighlight {
  id: string
  article_id: string
  user_id: string
  text: string
  note: string | null
  color: string
  position_data: Record<string, unknown> | null
  interval: number
  ease: number
  review_count: number
  last_reviewed_at: string | null
  next_review_at: string | null
  created_at: string
  updated_at: string
}

export interface DbProfile {
  id: string
  email: string | null
  display_name: string | null
  avatar_url: string | null
  created_at: string
  updated_at: string
}
